import React, { memo, useMemo } from "react";

import { BettoGameGridPlaceholderCard, CARD_VARIANT, getGridComponentForVariant } from "./elements";
import { useBettoPlaceholderCount } from "./useBettoPlaceholderCount.js";

export const BettoGameGridPlaceholder = memo(
	({ cardVariant = CARD_VARIANT.GRID, GridComponent }) => {
		const placeholderCount = useBettoPlaceholderCount(cardVariant);
		const ResolvedGrid = useMemo(
			() => GridComponent ?? getGridComponentForVariant(cardVariant),
			[GridComponent, cardVariant]
		);

		return (
			<ResolvedGrid
				className="search-game-container"
				aria-hidden="true">
				{Array.from({ length: placeholderCount }, (_, index) => (
					<BettoGameGridPlaceholderCard
						key={`betto-game-placeholder-${index}`}
						$variant={cardVariant}
						aria-hidden="true"
					/>
				))}
			</ResolvedGrid>
		);
	}
);

BettoGameGridPlaceholder.displayName = "BettoGameGridPlaceholder";
